import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.deleteButton = {
    css: css`
        margin-left: 10px;
        /* border: 1px solid red; */
        background: #ffffff;
        border: 1px solid ${getColor("primary")};
        border-radius: unset;
        padding: 10px 34px;
        margin-bottom: 16px;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            line-height: 16px;
        }
        &:hover {
            background: #ffffff;
        }
    `,
    buttonType: "outline",
    variant: "secondary",
};
orderApprovalDetailsActionButtonsStyles.printButton = {
    // variant: "secondary",
    buttonType: "solid",
    css: css`
        background: ${getColor("primary")};
        border-radius: unset;
        border: unset;
        padding: 10px 34px;
        margin-bottom: 16px;
        span[class^="TypographyStyle"] {
            line-height: 16px;
        }
        &:hover {
            background: #545454;
        }
    `,
};
orderApprovalDetailsActionButtonsStyles.approveButton = {
    css: css`
        margin-left: 10px;
        background: ${getColor("primary")};
        border-radius: unset;
        border: unset;
        padding: 10px 34px;
        margin-bottom: 16px;
        span[class^="TypographyStyle"] {
            line-height: 16px;
        }
        &:hover {
            background: #545454;
        }
    `,
};

orderApprovalDetailsActionButtonsStyles.menuHiddenContainer = {
    above: "md",
    css: css`
        nav[class^="OverflowWrapper"] {
            button {
                background: none;
            }
        }
    `,
};
orderApprovalDetailsActionButtonsStyles.twoButtonModalStyles = {
    submitButton: {
        color: "secondary",
        css: css`
            border: 2px solid ${getColor("primary")};
            background: ${getColor("primary")};
            padding: 10px 34px;
            span {
                line-height: 16px;
            }
            &:hover {
                background: #545454 !important;
                border-color: #545454 !important;
            }
        `,
    },
    cancelButton: {
        variant: "secondary",
        css: css`
            margin-right: 10px;
            padding: 10px 34px;
            background: #ffffff;
            border: 1px solid ${getColor("primary")};
            color: ${getColor("text.main")};
            span {
                line-height: 16px;
            }
            &:hover {
                opacity: 0.3;
                border-color: rgb(65, 64, 65) !important;
                background: none !important;
                color: ${getColor("text.main")} !important;
            }
        `,
    },
};
